//
//
//
//
//
//
//
//
//
//
//
//
//

import card from './components/card.vue'
import { viewall } from '@/api/lalisai'
// import { getview } from '@/api/jfhl'
export default {
  components: { card },
  name: 'rule',
  props: {},
  data () {
    return {
      title: '活动规则',
      partyid: this.$route.params.id,
      explist: ''
    }
  },
  created () { },
  mounted () {
    this.view()
  },
  methods: {
    view () {
      viewall({
        id: 1
      }).then(data => {
        this.explist = data.obj.explist
      })
    }
  }
}
